import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
  OnChanges
} from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { isNullOrUndefined } from 'util'
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray
} from '@angular/forms'
import { BsModalRef, BsModalService } from 'ngx-bootstrap'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ToastrService } from '../../../../node_modules/ngx-toastr'

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit, OnDestroy {
  @ViewChild('templateDel') templateDel: TemplateRef<any>
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  @Output() emitCreateForm: EventEmitter<any> = new EventEmitter()
  @Input() editId
  @Input() displayCreatePage
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }

  mode = 'Create'
  modes = {
    CREATE: 'Create',
    UPDATE: 'Update'
  }

  note_tmp
  message
  modalRef: BsModalRef
  contactForm: FormGroup
  id
  symbol
  subscription: Subscription
  contactRole = []
  items = []
  companyId
  otheR
  rolesRespons
  readonlyFlag = false
  companyNameThai
  roleList: Array<any>
  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.companyId = response['companyIdPsims']
        this.companyNameThai = response['companyNameThai']
      })
    this.cpmService.getRoleList().subscribe(response => {
      this.roleList = response
      this.setContactFormCreate()
      this.scrollTo()
    })
  }

  initFromGroup(event) {
    this.setContactFormCreate()
    this.scrollTo()
    if (event.id) {
      this.cpmService.getContactProfile(event.id).subscribe(
        response => {
          if (response.editFlag === 'Y') {
            this.readonlyFlag = false
          } else {
            this.readonlyFlag = true
          }
          if (event.createBy === 'L') {
            this.contactForm.get('status').disable()
            this.setFormWhenContactComFromSetPortal(response)
          } else {
            this.contactForm.get('status').enable()
            this.setFormWhenContactComFromAE(response)
          }
        },
        err => {}
      )
    } else if (event.id === '') {
      this.getRoleList()
      this.readonlyFlag = false
    }
  }

  setFormWhenContactComFromSetPortal(data): void {
    this.setContactForm(data)
    this.getRoleListWithDisableSetPortal(data, true)
  }

  setFormWhenContactComFromAE(data): void {
    this.setContactForm(data)
    this.getRoleListWithDisableSetPortal(data, false)
  }

  getRoleListWithDisableSetPortal(response, setPortalLock) {
    this.items = []
    this.contactRole = []
    this.otheR = ''
    this.roleList.map((role, i) => {
      this.contactRole.push(role)
      this.items.push(
        this.formBuilder.group({
          inputCheck: [
            {
              value: response.role.map(x => x.id).includes(role.id),
              disabled: setPortalLock ? role.setportalFlag === 'Y' : false
            }
          ],
          id: role.id,
          description: role.description,
          seq: role.seq,
          setportalFlag: role.setportalFlag
        })
      )
    })
    const otherRoleId = this.roleList.find(x => x.description === 'Other').id
    const otherDescription = response.role.find(x => x.id === otherRoleId)
    if (otherDescription) {
      this.contactForm.controls.otherRole.setValue(otherDescription.description)
    }
    this.contactForm.controls.items = this.formBuilder.array(this.items)
    this.bindingSubscriptionRoleSelection()
  }

  getRoleList() {
    this.items = []
    this.contactRole = []
    this.otheR = ''
    this.roleList.map(role => {
      this.contactRole.push(role)
      this.items.push(
        this.formBuilder.group({
          inputCheck: [],
          id: role.id,
          description: role.description,
          seq: role.seq,
          setportalFlag: role.setportalFlag
        })
      )
    })
    this.contactForm.controls.items = this.formBuilder.array(this.items)
    this.bindingSubscriptionRoleSelection()
  }

  setContactFormCreate() {
    this.contactForm = this.formBuilder.group({
      mode: new FormControl('I'),
      id: new FormControl(''),
      companyId: new FormControl(this.companyId),
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      position: new FormControl(''),
      department: new FormControl(''),
      telOffice: new FormControl(''),
      telMobile: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.email]),
      status: new FormControl('Active'),
      note: new FormControl(''),
      rolesRespons: new FormControl(false, Validators.pattern('true')),
      items: this.formBuilder.array(this.items),
      otherRole: new FormControl(''),
      editFlag: new FormControl(''),
      priority: new FormControl('N')
    })
    this.note_tmp = ''
  }

  setContactForm(data) {
    this.contactForm = this.formBuilder.group({
      mode: new FormControl('U'),
      id: new FormControl(data.id),
      companyId: new FormControl(this.companyId),
      firstName: new FormControl(data.firstName),
      lastName: new FormControl(data.lastName),
      position: new FormControl(data.position),
      department: new FormControl(data.department),
      telOffice: new FormControl(data.telOffice),
      telMobile: new FormControl(data.telMobile),
      email: new FormControl(data.email, Validators.required),
      status: new FormControl(data.status),
      note: new FormControl(data.note),
      rolesRespons: new FormControl(false, Validators.pattern('true')),
      items: this.formBuilder.array(this.items),
      otherRole: new FormControl(''),
      editFlag: new FormControl(data.editFlag),
      priority: new FormControl(data.priority)
    })
    this.note_tmp = data.note
  }

  bindingSubscriptionRoleSelection(): void {
    this.setInvalidRolesSection()

    this.contactForm.controls.items.statusChanges.subscribe(() => {
      this.setInvalidRolesSection()
    })
  }

  setInvalidRolesSection(): void {
    const isSetPortalHasRole =
      (this.contactForm.controls.items as FormArray).controls.filter(
        x => x.get('inputCheck').value === true
      ).length > 0
    if (isSetPortalHasRole) {
      this.contactForm.controls.rolesRespons.setValue(true)
    } else {
      this.contactForm.controls.rolesRespons.setValue(false)
    }
  }

  onSubmit() {
    if (this.contactForm.valid) {
      const roles = this.contactForm
        .get('items')
        .value.filter(role => role.inputCheck === true)
        .map(x => x.id)
      const putData = {
        id: this.contactForm.get('id').value, // id === null is add new profile
        companyId: this.contactForm.get('companyId').value,
        firstName: this.contactForm.get('firstName').value,
        lastName: this.contactForm.get('lastName').value,
        position: this.contactForm.get('position').value,
        department: this.contactForm.get('department').value,
        telOffice: this.contactForm.get('telOffice').value,
        telMobile: this.contactForm.get('telMobile').value,
        email: this.contactForm.get('email').value,
        note: this.contactForm.get('note').value,
        otherRole: this.contactForm.get('otherRole').value,
        priority: this.contactForm.get('priority').value,
        status: this.contactForm.get('status').value,
        roles: roles
      }

      const formData = new FormData()
      formData.append(
        'contactProfile',
        new Blob([JSON.stringify(putData)], { type: 'application/json' })
      )
      this.cpmService
        .insertOrUpdateContract(this.contactForm.get('mode').value, formData)
        .subscribe(
          success => {
            this.message = success.status
            if (this.message === 'OK') {
              this.toastr.success('การบันทึกรายการสำเร็จแล้ว')
              this.emitCreateForm.emit(this.symbol)
            } else {
              this.message = 'บันทึกรายการไม่สำเร็จ'
              this.openModal(this.templateSaved)
            }
          },
          error => {
            this.message = 'บันทึกรายการไม่สำเร็จ'
            this.openModal(this.templateSaved)
          }
        )
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }

  public goBack() {
    this.modalRef.hide()
    this.emitCreateForm.emit(this.symbol)
  }

  onCancle() {
    this.emitCreateForm.emit(this.symbol)
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  onSelectionChangeStatus(event) {
    this.contactForm.get('status').setValue(event)
    const fCon = this.contactForm.controls
    fCon.status.setValue(event)
  }

  onSelectionChangePriority(event) {
    const fCon = this.contactForm.controls
    this.contactForm.get('priority').setValue(event)
    fCon.priority.setValue(event)
  }

  get isRoleValid(): Boolean {
    return this.contactForm.controls.rolesRespons.valid
  }
  scrollTo() {
    const elmnt = document.getElementById('contactFormScroll')
    if (elmnt) {
      elmnt.scrollIntoView()
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/contact-form/contact-form.component.ts